import React from "react";
import { colors2, UI_BODY_SM_DF } from "oolib";

/**
 * Renders a 0-1 numeric value as a percentage (e.g. 0.82 → "82%").
 *
 * Pass `decimals` (default 0) via colConfig.props to control precision —
 * 0 gives whole-number percentages, 1 gives one decimal place, etc.
 */
const TablePercent = ({ value, decimals = 0 }) => {
  if (value === undefined || value === null) return null;
  const numeric = Number(value);
  if (Number.isNaN(numeric)) return null;
  const pct = (numeric * 100).toFixed(decimals);
  return (
    <UI_BODY_SM_DF style={{ color: colors2.grey80 }}>{pct}%</UI_BODY_SM_DF>
  );
};

export default TablePercent;
